import { render, staticRenderFns } from "./WsInfoLocales.vue?vue&type=template&id=50bc17a0&"
import script from "./WsInfoLocales.vue?vue&type=script&lang=js&"
export * from "./WsInfoLocales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports